import {
  fetchInquiryTemplateAndVersion,
  fetchInquiryTemplateVersionSchema,
  fetchInquiryTemplateVersionStepsPreview,
} from 'dashboard/apps/InquiryTemplateEditor/utils/inquiry-template-version';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Inquiry } from 'dashboard/models/inquiry';
import {
  setInquiry,
  setInquiryTemplate,
  setInquiryTemplateVersion,
  setInquiryTemplateVersionSchema,
  setInquiryTemplateVersionStepsPreview,
} from 'dashboard/redux/slices/inquiry-inspect';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { InquiryIso6391LanguageCode } from 'lib/constants/locales';
import { ApiModel } from 'lib/interfaces/api';

export const loadInquiryTemplateData =
  (inquiryTemplateVersionId: string, locale: InquiryIso6391LanguageCode): DashboardThunkAction =>
  async (dispatch) => {
    const [
      { inquiryTemplateVersion, inquiryTemplate },
      inquiryTemplateVersionSchema,
      inquiryTemplateVersionStepsPreview,
    ] = await Promise.all([
      fetchInquiryTemplateAndVersion({
        inquiryTemplateVersionId,
      }),
      fetchInquiryTemplateVersionSchema({
        inquiryTemplateVersionId,
      }),
      fetchInquiryTemplateVersionStepsPreview({
        inquiryTemplateVersionId,
        locale,
      }),
    ]);

    dispatch(setInquiryTemplateVersionSchema({ inquiryTemplateVersionSchema }));
    dispatch(setInquiryTemplate({ inquiryTemplate }));
    dispatch(setInquiryTemplateVersion({ inquiryTemplateVersion }));
    dispatch(setInquiryTemplateVersionStepsPreview({ inquiryTemplateVersionStepsPreview }));
  };

export const createInquiry =
  ({
    inquiryTemplateId,
    inquiryTemplateVersionId,
    referenceId,
    accountTypeId,
    fields,
    envId,
  }: {
    inquiryTemplateId: string;
    inquiryTemplateVersionId: string;
    referenceId?: string;
    accountTypeId?: string;
    fields?: Record<string, unknown>;
    envId: string;
  }): DashboardThunkAction =>
  async (dispatch) => {
    const { data: inquiry } = await SessionClientDashboard.postResourceCreate<
      Inquiry,
      {
        type: ApiModel.Inquiry;
        attributes: {
          'inquiry-template-version-id': string;
          'inquiry-template-id': string;
          'reference-id': string | undefined;
          'account-type-id': string | undefined;
          fields: Record<string, unknown>;
        };
      }
    >(
      {
        type: ApiModel.Inquiry,
        attributes: {
          'inquiry-template-id': inquiryTemplateId,
          'inquiry-template-version-id': inquiryTemplateVersionId,
          'reference-id': referenceId,
          'account-type-id': accountTypeId,
          fields: fields || {},
        },
      },
      {
        headers: {
          'Persona-Environment-ID': envId,
        },
      },
    );
    dispatch(setInquiry({ inquiry }));
  };
